import { useState } from 'react';
import {
  facility_details_for_Facility,
  facility_details_for_field,
  hfrVerify,
  roledetails,
  userdetails,
} from '../../../constants';

export const createInitialUserFormState = () => ({
  fName: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  lName: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  user_type: {
    isError: false,
    message: '',
    id: '',
    code: undefined,
    isDisable: false,
    value: '',
  },
  designation: {
    isError: false,
    message: '',
    id: '',
    code: undefined,
    isDisable: false,
    value: '',
  },
  mob: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  a_mob: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  email: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  doj: {
    isError: false,
    message: '',
    isDisable: false,
    value: null,
  },
  hpr_id: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  },
  abha_id: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  },
  user_status: {
    isError: false,
    message: '',
    isDisable: false,
    value: true,
  },
});

export const createInitialRoleFormState = () => ({
  role_name: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
    compositeRoleId: '',
  },
  state: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: '',
  },
  zone_div_circle: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  district: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  sub_district: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  sub_division: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  health_block: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  rural_urban: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  block: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  village: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  gram_panchayat: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  ulb: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  ward: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
    code: undefined,
  },
  reportUserWithLineListingData: {
    isError: false,
    message: '',
    isDisable: false,
    value: false,
  },
  offlineModeAccess: {
    isError: false,
    message: '',
    isDisable: false,
    value: false,
  },
  mfa: {
    isError: false,
    message: '',
    isDisable: false,
    value: true,
  },
});

export const createInitialFacilityFormState = () => ({
  hfr_id: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  health_facility_type: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
  },
  health_facility_name: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
  },
  health_provider_tagged: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: [],
  },
  ward: {
    isError: false,
    message: '',
    isDisable: false,
    value: [],
    id: [],
    code: [],
  },
  village: {
    isError: false,
    message: '',
    isDisable: false,
    value: [],
    id: [],
    code: [],
  },
  gram_panchayat: {
    isError: false,
    message: '',
    isDisable: false,
    value: [],
    id: [],
    code: [],
  },
  mobiliser_tagged: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
  },
  volunteerForPmsma: {
    isError: false,
    message: '',
    isDisable: false,
    value: false,
  },
});

export const createInitialFieldFormState = () => ({
  hfr_id: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  health_facility_type: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
  },
  health_facility_name: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
  },
  health_provider_tagged: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: [],
  },
  mobiliser_tagged: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    id: '',
  },
  ward: {
    isError: false,
    message: '',
    isDisable: false,
    value: [],
    id: [],
    code: [],
  },
  village: {
    isError: false,
    message: '',
    isDisable: false,
    value: [],
    id: [],
    code: [],
  },
  gram_panchayat: {
    isError: false,
    message: '',
    isDisable: false,
    value: [],
    id: [],
    code: [],
  },
});

export const useCreateNewUserFormState = () => {
  const [formState1, setFormState1] = useState(createInitialUserFormState);
  const [roleFormState, setRoleFormState] = useState(createInitialRoleFormState);
  const [userData, setUserData] = useState(userdetails);
  const [ruralUrban, setRuralUrban] = useState('');
  const [ruralUrbanId, setRuralUrbanId] = useState('');
  const [formStateForFacility, setFormStateForFacility] = useState(createInitialFacilityFormState);
  const [formStateForField, setFormStateForField] = useState(createInitialFieldFormState);
  const [roleFormData, setRoleFormData] = useState(roledetails);
  const [facilityFormData, setfacilityFormData] = useState(facility_details_for_Facility);
  const [fieldFormData, setfieldFormData] = useState(facility_details_for_field);
  const [hfrVerifyFormData, setHfrVerifyFormData] = useState(hfrVerify);

  return {
    formState1,
    setFormState1,
    roleFormState,
    setRoleFormState,
    userData,
    setUserData,
    ruralUrban,
    setRuralUrban,
    ruralUrbanId,
    setRuralUrbanId,
    formStateForFacility,
    setFormStateForFacility,
    formStateForField,
    setFormStateForField,
    roleFormData,
    setRoleFormData,
    facilityFormData,
    setfacilityFormData,
    fieldFormData,
    setfieldFormData,
    hfrVerifyFormData,
    setHfrVerifyFormData,
  };
};
